<template>
  <div class="chat">
    <!-- {{formParamSRSt}} -->
    <!-- {{linkRows}} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content" style=" overflow-wrap: break-word;">
                <div
                  class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type=='image' && formParamQRSt.header.button_type!='list_text'"
                >
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamQRSt.header.image_url" />
                  </a>
                </div>
                <ul
                  class="attach-list"
                  v-if="formParamQRSt.header.message_type=='document' && formParamQRSt.header.button_type!='list_text'"
                >
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                  </li>
                </ul>
                <p
                  v-html="messageFilter(formParamQRSt.header.message)"
                  v-if="formParamQRSt.header.message!=''"
                  v-linkified
                ></p>
                <span
                  v-html="formParamQRSt.header.footer_message"
                  class="text-muted"
                  style="font-size:10px;"
                  v-linkified
                  v-if="formParamQRSt.header.footer_message_status==true"
                ></span>
                <template v-if="formParamQRSt.detail_button.length">
                  <div v-if="formParamQRSt.header.button_type=='button'">
                    <div
                      class="text-center"
                      v-for="(rowVal,idx) in formParamQRSt.detail_button"
                      :key="idx"
                    >
                      <div
                        class="user-add-shedule-list"
                        v-if="rowVal.auto_reply_button_id!='' && idx<3"
                      >
                        <a href="javascript:void(0)">
                          <i class="fa fa-tags"></i>
                          {{getButtonLabelById(rowVal.auto_reply_button_id)}}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="formParamQRSt.header.button_type=='list_text'">
                    <table class="table table-nowrap">
                      <template v-for="(rowVal,idx) in formParamQRSt.detail_button">
                        <tr v-if="rowVal.auto_reply_button_id!=''" :key="idx">
                          <td>
                            <label
                              :for="rowVal.auto_reply_button_id"
                            >{{getButtonLabelById(rowVal.auto_reply_button_id)}}</label>
                          </td>
                          <td>
                            &nbsp;
                            <input
                              disabled
                              name="radio_list_text"
                              class="form-check-input"
                              :id="rowVal.auto_reply_button_id"
                              type="radio"
                            />
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                  <div v-if="formParamQRSt.header.button_type=='link'">
                    <div
                      class="text-center"
                      v-for="(rowVal,idx) in formParamQRSt.detail_button"
                      :key="idx"
                    >
                      <div
                        class="user-add-shedule-list"
                        v-if="rowVal.auto_reply_button_id!='' && idx<3"
                      >
                        <a
                          href="javascript:void(0)"
                          v-html="getLinkLabelById(rowVal.auto_reply_button_id)"
                        ></a>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div
                class="chat-content"
                style=" overflow-wrap: break-word;"
                v-if="(formParamQRSt.header.message_type=='image' || formParamQRSt.header.message_type=='document') && formParamQRSt.header.button_type=='list_text'"
              >
                <div
                  class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type=='image' && formParamQRSt.header.button_type=='list_text'"
                >
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamQRSt.header.image_url" />
                  </a>
                </div>
                <ul
                  class="attach-list"
                  v-if="formParamQRSt.header.message_type=='document' && formParamQRSt.header.button_type=='list_text'"
                >
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="formParamQRSt.header.is_enable_away_message_status==true" />
      <div class="chats" v-if="formParamQRSt.header.is_enable_away_message_status==true">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
                <p
                  v-html="messageFilter(formParamQRSt.header.message_away)"
                  v-if="formParamQRSt.header.message_away!=''"
                  v-linkified
                ></p>
                <span
                  v-html="formParamQRSt.header.footer_message"
                  class="text-muted"
                  style="font-size:10px;"
                  v-linkified
                  v-if="formParamQRSt.header.footer_message_status==true"
                ></span>
                <template v-if="formParamQRSt.detail_button_away.length">
                  <div v-if="formParamQRSt.header.button_type_away_message=='button'">
                    <div
                      class="text-center"
                      v-for="(rowVal,idx) in formParamQRSt.detail_button_away"
                      :key="idx"
                    >
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id!=''">
                        <a href="javascript:void(0)">
                          <i class="fa fa-tags"></i>
                          {{getButtonLabelById(rowVal.auto_reply_button_id)}}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="formParamQRSt.header.button_type_away_message=='link'">
                    <div
                      class="text-center"
                      v-for="(rowVal,idx) in formParamQRSt.detail_button_away"
                      :key="idx"
                    >
                      <div class="user-add-shedule-list" v-if="rowVal.auto_reply_button_id!=''">
                        <a
                          href="javascript:void(0)"
                          v-html="getLinkLabelById(rowVal.auto_reply_button_id)"
                        ></a>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {
    formParamQRSt() {
      return this.$store.state.automation.formParamQRSt;
    }
  },
  methods: {
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/operator/preview.vue